import {injectable} from "inversify";
import {IconEnum} from "@/modules/vue/enums";

export type DialogType = {
  type?: 'success' | 'info' | 'error'
  title?: string,
  text: string,
  closable?: boolean,
  icon?: IconEnum,
}

@injectable()
export class DialogService {
  public show: (dialog: DialogType) => void;
  public hide: () => void;

  public init(options: { show: (dialog: DialogType) => void, hide: () => void }) {
    this.show = options.show;
    this.hide = options.hide;
  }

  showDialog(dialog: DialogType) {
    this.show(dialog);
  }

  showLoading() {
    this.show({
      type: 'info',
      text: translator.t('loading...'),
      closable: false,
      icon: IconEnum.ClockRegular,
    });
  }

  async doLoading(callback: () => Promise<any>) {
    this.showLoading();
    await callback();
    this.hide();
  }
}